import { PatientInfoForm } from './PatientInfoForm'
import { useGetPatientInfo } from '../model/useGetPatientInfo'
import { Paper, Typography } from '@mui/material'
import { Trans } from '@lingui/macro'

import colors from '@/assets/scss/_themes-vars.module.scss'

export function PatientInfo({ patientId }: { patientId: string }) {
  const { patient } = useGetPatientInfo({ patientId })

  if (!patient) return null

  return (
    <Paper sx={{ px: 2, pb: 2 }}>
      <Typography py={2.5} variant="h3" sx={{ color: colors.gray900, fontSize: '18px', fontWeight: 500, lineHeight: '24px', mb: '4px' }}>
        <Trans>Patient information</Trans>
      </Typography>
      <PatientInfoForm patient={patient} readOnly={true} />
    </Paper>
  )
}
